import React, { useState, useEffect, useContext } from 'react';
import { TableRow, TableCell, Checkbox, TextField } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import _ from 'lodash';

import Icon from '../../../components/Icon/Icon';
import Button from 'src/components/Button/Button';
import AddMeetingContext from 'src/pages/AddMeeting/Context/AddMeeting.context';

const MARKETS = {
  tote: [
    { name: 'WIN' },
    { name: 'PLACE' },
    { name: 'SHOW' },
    { name: 'EXACTA' },
    { name: 'SWINGER' },
    { name: 'DOUBLE' },
    { name: 'TRIFECTA' },
    { name: 'QUARTETT' },
    { name: 'JACKPOT' },
    { name: 'PICK 3', amount: 3 },
    { name: 'PICK 6', amount: 6 },
    { name: 'PICK 7', amount: 7 },
    { name: 'PICK 8', amount: 8 },
    { name: 'PICK 9', amount: 9 },
    { name: 'PICK 10', amount: 10 },
    { name: 'PLACEACCA' },
    { name: 'BIPOT' },
    { name: 'ROULETTE' },
    { name: 'QUINELLA' },
    { name: 'TRIO' }
  ],
  sp: [
    { name: 'WIN' },
    { name: 'PLACE' },
    { name: 'EACH WAY' }
  ],
  fixedOdds: [
    { name: 'WIN' },
    { name: 'PLACE' },
    { name: 'EACH WAY' },
    { name: '2 Places' },
    { name: '3 Places' },
    { name: '4 Places' },
    { name: '5 Places' },
    { name: '6 Places' },
    { name: '7 Places' },
    { name: '8 Places' },
    { name: '9 Places' },
    { name: '10 Places' },
    { name: 'Ita' },
    { name: 'Trita' },
    { name: 'Not To win' },
    { name: 'Not Top 2 Places' },
    { name: 'Not Top 3 Places' },
    { name: 'Not Top 4 Places' },
    { name: 'Not Top 5 Places' },
    { name: 'Not Top 6 Places' },
    { name: 'Not Top 7 Places' },
    { name: 'Not Top 8 Places' },
    { name: 'Not Top 9 Places' },
    { name: 'Not Top 10 Places' },
    { name: 'SWINGER' },
    { name: 'FORECAST' },
    { name: 'TRICAST' },
    { name: 'QUARTETT' },
    { name: 'QUINELLA' },
    { name: 'TRIO' },
    { name: 'WINNER WITHOUT' },
    { name: 'Cover Bet 2 places' },
    { name: 'Cover Bet 3 places' },
    { name: 'Cover Bet 4 places' },
    { name: 'WIN Stable' },
    { name: 'WIN Group' },
    { name: 'Head to head 2-way', amount: 2 },
    { name: 'Head to head 3-way', amount: 3 },
    { name: 'Free text', freeText: true, amount: 1 }
  ]
};

export default function RaceRowMarket({ indexRace }: any) {
  const { t } = useTranslation('common');
  const { formData } = useContext(AddMeetingContext);
  const [ tote, setTote ] = useState(false);
  const [ fixedOdds, setFixedOdds ] = useState(false);
  const [ sp, setSp ] = useState(false);
  const [selectedMarkets, setSelectedMarkets] = useState([]);

  useEffect(() => {
    if (`markets_${ indexRace }` in formData) {
      setSelectedMarkets(JSON.parse(formData[`markets_${ indexRace }`]));
    }
  }, []);

  useEffect(() => {
    setTote(!!_.find(selectedMarkets, { marketType: 'tote' }));
    setFixedOdds(!!_.find(selectedMarkets, { marketType: 'fixedOdds' }));
    setSp(!!_.find(selectedMarkets, { marketType: 'sp' }));
  }, [selectedMarkets]);

  const onMarketSelection = (market, marketType: string) => (e) => {
    e.preventDefault();

    const _selectedMarkets = [...selectedMarkets];
    const clickedMarketIndex = _.findIndex(_selectedMarkets, { marketType, name: market.name });

    if (clickedMarketIndex !== -1) {
      _.pullAt(_selectedMarkets, clickedMarketIndex);
    } else {
      _selectedMarkets.push({ ...market, marketType });
    }

    setSelectedMarkets(_selectedMarkets);
  };

  const onMarketValueChange = (market, marketType, valuesIndex, index) => (e) => {
    e.preventDefault();

    const _selectedMarkets = [...selectedMarkets];
    const _market = _.find(_selectedMarkets, { marketType, name: market.name });

    if (!('values' in _market)) _market.values = [[]];

    _market.values[valuesIndex][index] = e.target.value;

    setSelectedMarkets(_selectedMarkets);
  };

  const onFreeTextValueChange = (market, marketType, valuesIndex, index) => (e) => {
    e.preventDefault();
    const _selectedMarkets = [...selectedMarkets];
    const _market = _.find(_selectedMarkets, { marketType, name: market.name });
    const { target: { value, name } } = e;

    if (index === false) {
      _market[name] = value;
      setSelectedMarkets(_selectedMarkets);
      return;
    }

    if (!('values' in _market)) _market.values = [[], []];

    _market.values[valuesIndex][index] = value;

    setSelectedMarkets(_selectedMarkets);
  };

  const onRowChange = (type, marketType, market) => (e) => {
    e.preventDefault();

    const _selectedMarkets = [...selectedMarkets];
    const _market = _.find(_selectedMarkets, { marketType, name: market.name });

    if (!('values' in _market)) {
      _market.values = [[]];
    } else if (type === 'remove') {
      _market.values.pop();
    } else if (type === 'add') {
      _market.values.push([]);
    }

    setSelectedMarkets(_selectedMarkets);
  };

  const renderFreetext = (marketType) => {
    const marketsList = _.filter(selectedMarkets, m => m.freeText && m.marketType === marketType);

    return (
      <div>
        {
          _.map(marketsList, (market, index: number) => {
            const marketValues = market.values || [[], []];

            return (
              <React.Fragment key={ market }>
                <div className="add-meeting-form__list-line">
                  <span className="add-meeting-form__list-title add-meeting-form__list-title--secondary">
                    { t('addMeetingForm.market') }
                  </span>
                  <div className="add-meeting-form__wrapper">
                    <div className="add-meeting-form__list-container">
                      <div className="add-meeting-form__list-input">
                        <TextField
                          placeholder={ t('addMeetingForm.name') }
                          variant="outlined"
                          className="add-meeting-form__input add-meeting-form__input--full-width"
                          name="marketName"
                          type="text"
                          onChange={ onFreeTextValueChange(market, marketType, index, false) }
                          value={ market?.marketName }
                          required
                        />
                      </div>
                      <div className="add-meeting-form__list-input add-meeting-form__list-input--free-text">
                        <span className="add-meeting-form__list-label">{ t('addMeetingForm.nrOutcomes') }</span>
                        <TextField
                          variant="outlined"
                          className="add-meeting-form__input"
                          name="nrOutcomes"
                          type="number"
                          onChange={ onFreeTextValueChange(market, marketType, index, false) }
                          value={ market?.nrOutcomes }
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="add-meeting-form__list-line add-meeting-form__list-line--no-line">
                  <span className="add-meeting-form__list-title add-meeting-form__list-title--secondary">
                    <Button
                      className="add-meeting-form__list-add add-meeting-form__list-add--space"
                      onClick={ onRowChange('add', marketType, market) }
                    >
                      <Icon icon="more" className="add-meeting-form__icon add-meeting-form__icon--small" />
                    </Button>
                    {
                      marketValues.length > 2 && (
                        <Button
                          className="add-meeting-form__list-add add-meeting-form__list-add--space"
                          onClick={ onRowChange('remove', marketType, market) }
                        >
                          <Icon icon="less" className="add-meeting-form__icon add-meeting-form__icon--small" />
                        </Button>
                      )
                    }
                  </span>
                  <div className="add-meeting-form__wrapper">
                    <div className="add-meeting-form__list-container">
                      {
                        _.map(marketValues, (values, outcome) => (
                          <div key={ values + outcome } className="add-meeting-form__list-input add-meeting-form__list-input--border">
                            <span className="add-meeting-form__list-label">{ t('addMeetingForm.outcomes') } { outcome + 1 }</span>
                            <TextField
                              placeholder={ t('addMeetingForm.name') }
                              variant="outlined"
                              className="add-meeting-form__input add-meeting-form__input--full-width"
                              name="marketName"
                              type="text"
                              value={ values[outcome] }
                              onChange={ onFreeTextValueChange(market, marketType, index, outcome) }
                              required
                            />
                          </div>
                        ))
                      }
                    </div>
                  </div>
                </div>
              </React.Fragment>
            );
          })
        }
      </div>
    );
  };

  const renderMarketList = (marketType) => {
    const marketsList = _.filter(selectedMarkets, m => m.amount > 0 && !m.freeText && m.marketType === marketType);

    return (
      <div className="add-meeting-form__list">
        <div className="add-meeting-form__list-header">
          <span className="add-meeting-form__list-title">{ t(`addMeetingForm.${ marketType }`) }</span>
          <div className="add-meeting-form__list-options">
            {
              _.map(MARKETS[marketType], (market) =>
                <Button
                  key={ market.name }
                  className={
                    classNames({
                      'add-meeting-form__list-btn' : true,
                      'add-meeting-form__list-btn--selected': _.find(selectedMarkets, { marketType, name: market.name })
                    })
                  }
                  onClick={ onMarketSelection(market, marketType) }
                >
                  { market.name }
                </Button>
              )
            }
          </div>
        </div>
        {
          _.map(marketsList, (market) => {
            const marketValues = market.values || [[]];

            return (
              <div key={ market.name } className="add-meeting-form__list-line">
                <span className="add-meeting-form__list-title add-meeting-form__list-title--secondary">{ market.name }</span>
                <div>
                  {
                    _.map(marketValues, (values, index: number) => (
                      <div key={ values + index } className="add-meeting-form__list-container">
                        {
                          _.map(_.range(market.amount), (leg: number) => {
                            return (
                              leg === 0 ?
                                <div key={ market.name + leg } className="add-meeting-form__disable">
                                  <span className="add-meeting-form__list-label">{ t(`addMeetingForm.${ market.marketType }Input`) } { leg+1 }</span>
                                  <span className="add-meeting-form__list-label add-meeting-form__list-label--text">Race { leg+1 } (this)</span>
                                </div>
                                :
                                <div key={ market.name + leg } className="add-meeting-form__list-input">
                                  <span className="add-meeting-form__list-label">{ t(`addMeetingForm.${ market.marketType }Input`) } { leg+1 }</span>
                                  <TextField
                                    placeholder={ t(`addMeetingForm.${ market.marketType }Label`) }
                                    variant="outlined"
                                    className="add-meeting-form__input add-meeting-form__input--event"
                                    name="numberRaces"
                                    type="text"
                                    value={ values[leg] }
                                    onChange={ onMarketValueChange(market, marketType, index, leg) }
                                    required
                                  />
                                </div>
                            );
                          })
                        }
                        {
                          marketType === 'fixedOdds' && (
                            <div className="add-meeting-form__list-input">
                              {
                                index > 0 && (
                                  <Button
                                    className="add-meeting-form__list-add add-meeting-form__list-add--space"
                                    onClick={ onRowChange('remove', marketType, market) }
                                  >
                                    <Icon
                                      icon="less"
                                      className="add-meeting-form__icon add-meeting-form__icon--small"
                                    />
                                  </Button>
                                )
                              }
                              <Button
                                className="add-meeting-form__list-add add-meeting-form__list-add--space"
                                onClick={ onRowChange('add', marketType, market) }
                              >
                                <Icon
                                  icon="more"
                                  className="add-meeting-form__icon add-meeting-form__icon--small"
                                />
                              </Button>
                            </div>
                          )
                        }
                      </div>
                    ))
                  }
                </div>
              </div>
            );
          })
        }
        { _.find(selectedMarkets, { freeText: true }) && renderFreetext(marketType) }
      </div>
    );
  };

  return (
    <TableRow>
      <TableCell className="add-meeting-form__cell add-meeting-form__cell--no-space" colSpan={ 8 }>
        <input type="hidden" name={ `markets_${ indexRace }` } value={ JSON.stringify(selectedMarkets) } data-race={ indexRace } />
        <div className="add-meeting-form__market">
          <h2 className="add-meeting-form__subtitle">{ t('addMeetingForm.name') }</h2>
          <div className="add-meeting-form__type">
            <span className="add-meeting-form__label">{ t('addMeetingForm.tote') }</span>
            <Checkbox
              name="checkBoxSelected"
              color="primary"
              className="add-meeting-form__icon"
              checked={ tote }
              onChange={ () => setTote(!tote) }
              icon={ <Icon icon="checkboxSmall" className="add-meeting-form__icon" /> }
              checkedIcon={ <Icon icon="checked" className="add-meeting-form__icon" /> }
            />
            <span className="add-meeting-form__label">{ t('addMeetingForm.fixedOdds') }</span>
            <Checkbox
              name="checkBoxSelected"
              color="primary"
              className="add-meeting-form__icon"
              checked={ fixedOdds }
              onChange={ () => setFixedOdds(!fixedOdds) }
              icon={ <Icon icon="checkboxSmall" className="add-meeting-form__icon" /> }
              checkedIcon={ <Icon icon="checked" className="add-meeting-form__icon" /> }
            />
            <span className="add-meeting-form__label">{ t('addMeetingForm.sp') }</span>
            <Checkbox
              name="checkBoxSelected"
              color="primary"
              className="add-meeting-form__icon"
              checked={ sp }
              onChange={ () => setSp(!sp) }
              icon={ <Icon icon="checkboxSmall" className="add-meeting-form__icon" /> }
              checkedIcon={ <Icon icon="checked" className="add-meeting-form__icon" /> }
            />
          </div>
          { tote && renderMarketList('tote') }
          { fixedOdds && renderMarketList('fixedOdds') }
          { sp && renderMarketList('sp') }
        </div>
      </TableCell>
    </TableRow>
  );
}
